import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { message, Popover } from "antd";
// import { Row, Col } from 'antd';
import moment from "moment";
import WidgetHeader from "../../../components/WidgetHeader";
import {
  buildRowsPdfAttachment,
  describeDataFilters,
  exportRowsToCsv,
  exportRowsToPdf,
  exportRowsToPng,
  exportRowsToXlsx,
} from "../../../utils/widgetExport";
import _ from "lodash";
import { v4 } from "uuid";
import ReportGrid from "../../../components/ReportGrid";
import { getCurrentDate } from "../../../utils/date-time";
import { DATE_FORMAT } from "../../../constants/dateConstants";
import {
  getSumOfGroupByMultiFields,
  groupingByMultipleFields,
} from "../../../utils/group-helpers";
import { applyDataFilters, isFilterActive } from "../../../utils/dataFilterEngine";
import ColumnDataFilter from "../Filters/ColumnDataFilter";
import "../Filters/widgetFilters.css";

export default function BoardDataTableContainer(props) {
  const user = useSelector((state) => state.user);
  const [displayData, setDisplayData] = useState(
    props?.reportData?.length ? props.reportData : { data: [] }
  );
  const [fieldNames, setFieldNames] = useState();
  // the element the per-widget Full screen button expands
  const widgetRef = useRef(null);

  useEffect(() => {
    init();
    async function init() {
      if (
        props.aggregation &&
        props.aggregation.row &&
        props.aggregation.row.length > 0
      ) {
        let withAggr = [];
        let reportData = await JSON.parse(JSON.stringify(props.reportData))
          .data;

        Object.preventExtensions(reportData);

        reportData.forEach((cd, i) => {
          props.aggregation.row.forEach((ag, j) => {
            switch (ag.rowAggregation[0].operator) {
              case "add_c":
                if (ag.rowAggregation[0].fieldName) {
                  reportData[i][ag?.displayName] = Number(
                    Number(cd[ag.rowAggregation[0].fieldName]) +
                    Number(ag.rowAggregation[0].const_1)
                  ).toFixed(2);
                  return;
                }
                break;
              case "multiply_c":
                if (ag.rowAggregation[0].fieldName) {
                  reportData[i][ag?.displayName] = (
                    Number(cd[ag.rowAggregation[0].fieldName]) *
                    Number(ag.rowAggregation[0].const_1)
                  ).toFixed(2);
                  return;
                }
                break;
              case "sum":
                if (ag.rowAggregation[0].fieldNamesList) {
                  reportData[i][ag?.displayName] = Number(
                    ag.rowAggregation[0].fieldNamesList &&
                    ag.rowAggregation[0].fieldNamesList.reduce((a, b) => {
                      return Number(a) + Number(reportData[i][b]);
                    }, 0)
                  ).toFixed(2);
                  return;
                }
                break;
              case "avg":
                if (ag.rowAggregation[0].fieldNamesList) {
                  reportData[i][ag?.displayName] = (
                    ag.rowAggregation[0].fieldNamesList.reduce((a, b) => {
                      return a + Number(reportData[i][b]);
                    }, 0) / ag.rowAggregation[0].fieldNamesList.length
                  ).toFixed(2);
                  return;
                }
                break;
              case "func":
                if (ag.rowAggregation[0].calculationStr) {
                  let fcn = ag.rowAggregation[0].calculationStr
                    .replaceAll(" ", "")
                    .replaceAll("@", "Number(cd['")
                    .replaceAll("$", "'])");
                  reportData[i][ag?.displayName] = Number(eval(fcn)).toFixed(2);
                  return;
                }
                break;
              default:
                return reportData[i];
            }
          });
        });

        let availableFieldsSet = props?.availableFields
          ?.filter((x) => x.checked)
          ?.map((af, i) => {
            return {
              title: af.fieldName,
              dataIndex: af.fieldName,
              key: af.fieldName,
              dataType: af.dataType,
              format: af.format,
              fieldDisplayName: af.fieldDisplayName || null,
              // the width saved by the editor; ReportGrid auto-fits when it is absent
              width: af.width
            };
          });

        props?.aggregation?.row?.forEach((a, k) => {
          availableFieldsSet.push({
            title: a.displayName,
            dataIndex: a.displayName,
            key: a.displayName,
            isAggrCol: true,
            className: "aggr-col",
          });
        });

        setFieldNames(availableFieldsSet);
        setDisplayData({ data: reportData });
        withAggr = reportData;

        /* One shared engine for both views - see src/utils/dataFilterEngine.js. The
           inline chain this replaces is kept below for reference; it re-filtered the
           original rows for every filter (so filters could not stack), never
           implemented Contains, and skipped Between because it has no `value`. */
        setDisplayData({
          data: applyDataFilters(withAggr, props?.dataFilters, props?.availableFields),
        });

        /* if (props?.dataFilters?.length > 0 && displayData?.data) {
          let updateData = withAggr;

          for (let i = 0; i < props.dataFilters.length; i++) {
            const selectedFieldName = props.dataFilters[i].fieldName;
            const format = props?.availableFields?.find(
              (f) => f?.fieldName === selectedFieldName
            )?.format;

            if (props.dataFilters[i].value) {
              if (props.dataFilters[i].filterType === "gt") {
                if (props.dataFilters[i].dataType === "date") {
                  setDisplayData({
                    data: updateData.filter(
                      (rd) =>
                        moment(moment(rd[props.dataFilters[i]["fieldName"]]).format(
                          format || DATE_FORMAT
                        )).isAfter(moment(props.dataFilters[i]["value"]).format(
                          format || DATE_FORMAT
                        ))
                    ),
                  });
                } else {
                  setDisplayData({
                    data: updateData.filter(
                      (rd) =>
                        Number(rd[props.dataFilters[i]["fieldName"]]) >
                        Number(props.dataFilters[i]["value"])
                    ),
                  });
                }
              } else if (props.dataFilters[i].filterType === "gte") {
                if (props.dataFilters[i].dataType === "date") {
                  setDisplayData({
                    data: updateData.filter(
                      (rd) =>
                        moment(moment(rd[props.dataFilters[i]["fieldName"]]).format(
                          format || DATE_FORMAT
                        )).isSameOrAfter(moment(props.dataFilters[i]["value"]).format(
                          format || DATE_FORMAT
                        ))
                    ),
                  });
                } else {
                  setDisplayData({
                    data: updateData.filter(
                      (rd) =>
                        Number(rd[props.dataFilters[i]["fieldName"]]) >=
                        Number(props.dataFilters[i]["value"])
                    ),
                  });
                }
              } else if (props.dataFilters[i].filterType === "lt") {
                if (props.dataFilters[i].dataType === "date") {
                  setDisplayData({
                    data: updateData.filter(
                      (rd) =>
                        moment(moment(rd[props.dataFilters[i]["fieldName"]]).format(
                          format || DATE_FORMAT
                        )).isBefore(moment(props.dataFilters[i]["value"]).format(
                          format || DATE_FORMAT
                        ))
                    ),
                  });
                } else {
                  setDisplayData({
                    data: updateData.filter(
                      (rd) =>
                        Number(rd[props.dataFilters[i]["fieldName"]]) <
                        Number(props.dataFilters[i]["value"])
                    ),
                  });
                }
              } else if (props.dataFilters[i].filterType === "lte") {
                if (props.dataFilters[i].dataType === "date") {
                  setDisplayData({
                    data: updateData.filter(
                      (rd) =>
                        moment(moment(rd[props.dataFilters[i]["fieldName"]]).format(
                          format || DATE_FORMAT
                        )).isSameOrBefore(moment(props.dataFilters[i]["value"]).format(
                          format || DATE_FORMAT
                        ))
                    ),
                  });
                } else {
                  setDisplayData({
                    data: updateData.filter(
                      (rd) =>
                        Number(rd[props.dataFilters[i]["fieldName"]]) <=
                        Number(props.dataFilters[i]["value"])
                    ),
                  });
                }
              } else if (props.dataFilters[i].filterType === "between") {
                if (props.dataFilters[i].dataType === "number") {
                  setDisplayData({
                    data: updateData.filter(
                      (rd) =>
                        Number(rd[props.dataFilters[i]["fieldName"]]) >
                        Number(props.dataFilters[i]["value1"]) &&
                        Number(rd[props.dataFilters[i]["fieldName"]]) <
                        Number(props.dataFilters[i]["value2"])
                    ),
                  });
                } else if (props.dataFilters[i].dataType === "date") {
                  setDisplayData({
                    data: updateData.filter(
                      (rd) =>
                        moment(moment(rd[props.dataFilters[i]["fieldName"]]).format(
                          format || DATE_FORMAT
                        )).isBetween(
                          moment(props.dataFilters[i]["value1"]).subtract(1, "days").format(format || DATE_FORMAT),
                          moment(props.dataFilters[i]["value2"]).add(1, "days").format(format || DATE_FORMAT)
                        )
                    ),
                  });
                }
              } else {
                // console.log("PROPS dataFilters Received , eq con", updateData[0][props.dataFilters[i]['fieldName']], props.dataFilters[i]['value'])
                const getFilterdData = () => {
                  if (props.dataFilters[i].dataType === "date") {
                    return updateData.filter(
                      (rd) =>
                        moment(rd[props.dataFilters[i]["fieldName"]]).format(format || DATE_FORMAT) ===
                        moment(props.dataFilters[i]["value"]).format(format || DATE_FORMAT)
                    );
                  } else {
                    return updateData.filter(
                      (rd) =>
                        String(rd[props.dataFilters[i]["fieldName"]]) ===
                        String(props.dataFilters[i]["value"])
                    );
                  }
                }


                setDisplayData({ data: getFilterdData() });
              }
            }
          }
        } else {
          setDisplayData({ data: reportData });
        } */
      } else {
        let availableFieldsSet = props?.availableFields
          ?.filter((x) => x.checked)
          ?.map((af, i) => {
            return {
              title: af.fieldName,
              dataIndex: af.fieldName,
              key: af.fieldName,
              dataType: af.dataType,
              format: af.format,
              fieldDisplayName: af.fieldDisplayName || null,
              // the width saved by the editor; ReportGrid auto-fits when it is absent
              width: af.width
            };
          });
        if (
          (props.selectedResource === null ||
            (props.selectedResource.connectionData &&
              props.selectedResource.connectionData.uid ===
              props.connectionData.uid)) &&
          props.dataFilters &&
          props.dataFilters.length > 0 &&
          displayData &&
          displayData.data
        ) {
          let updateData = [...displayData["data"]];

          for (let i = 0; i < props.dataFilters.length; i++) {
            const selectedFieldName = props.dataFilters[i].fieldName;
            const format = props?.availableFields?.find(
              (f) => f?.fieldName === selectedFieldName
            )?.format;
            if (props.dataFilters[i].value) {
              if (props.dataFilters[i].filterType === "gt") {
                if (props.dataFilters[i].dataType === "date") {
                  updateData = updateData.filter(
                    (rd) =>
                      moment(moment(rd[props.dataFilters[i]["fieldName"]]).format(
                        format || DATE_FORMAT
                      )).isAfter(moment(props.dataFilters[i]["value"]).format(
                        format || DATE_FORMAT
                      ))
                  );
                  setDisplayData({
                    data: updateData,
                  });
                } else {
                  updateData = updateData.filter(
                    (rd) =>
                      Number(rd[props.dataFilters[i]["fieldName"]]) >
                      Number(props.dataFilters[i]["value"])
                  );
                  setDisplayData({
                    data: updateData,
                  });
                }
              } else if (props.dataFilters[i].filterType === "gte") {
                if (props.dataFilters[i].dataType === "date") {
                  updateData = updateData.filter(
                    (rd) =>
                      moment(moment(rd[props.dataFilters[i]["fieldName"]]).format(
                        format || DATE_FORMAT
                      )).isSameOrAfter(moment(props.dataFilters[i]["value"]).format(
                        format || DATE_FORMAT
                      ))
                  );
                  setDisplayData({
                    data: updateData,
                  });
                } else {
                  updateData = updateData.filter(
                    (rd) =>
                      Number(rd[props.dataFilters[i]["fieldName"]]) >=
                      Number(props.dataFilters[i]["value"])
                  );
                  setDisplayData({
                    data: updateData,
                  });
                }
              } else if (props.dataFilters[i].filterType === "lt") {
                if (props.dataFilters[i].dataType === "date") {
                  updateData = updateData.filter(
                    (rd) =>
                      moment(moment(rd[props.dataFilters[i]["fieldName"]]).format(
                        format || DATE_FORMAT
                      )).isBefore(moment(props.dataFilters[i]["value"]).format(
                        format || DATE_FORMAT
                      ))
                  );
                  setDisplayData({
                    data: updateData,
                  });
                } else {
                  updateData = updateData.filter(
                    (rd) =>
                      Number(rd[props.dataFilters[i]["fieldName"]]) <
                      Number(props.dataFilters[i]["value"])
                  );
                  setDisplayData({
                    data: updateData,
                  });
                }
              } else if (props.dataFilters[i].filterType === "lte") {
                if (props.dataFilters[i].dataType === "date") {
                  updateData = updateData.filter(
                    (rd) =>
                      moment(moment(rd[props.dataFilters[i]["fieldName"]]).format(
                        format || DATE_FORMAT
                      )).isSameOrBefore(moment(props.dataFilters[i]["value"]).format(
                        format || DATE_FORMAT
                      ))
                  );
                  setDisplayData({
                    data: updateData,
                  });
                } else {
                  updateData = updateData.filter(
                    (rd) =>
                      Number(rd[props.dataFilters[i]["fieldName"]]) <=
                      Number(props.dataFilters[i]["value"])
                  );
                  setDisplayData({
                    data: updateData,
                  });
                }
              } else if (props.dataFilters[i].filterType === "between") {
                if (props.dataFilters[i].dataType === "number") {
                  updateData = updateData.filter(
                    (rd) =>
                      Number(rd[props.dataFilters[i]["fieldName"]]) >
                      Number(props.dataFilters[i]["value1"]) &&
                      Number(rd[props.dataFilters[i]["fieldName"]]) <
                      Number(props.dataFilters[i]["value2"])
                  );
                  setDisplayData({
                    data: updateData,
                  });
                } else if (props.dataFilters[i].dataType === "date") {
                  updateData = updateData.filter(
                    (rd) =>
                      moment(moment(rd[props.dataFilters[i]["fieldName"]]).format(
                        format || DATE_FORMAT
                      )).isBetween(
                        moment(props.dataFilters[i]["value1"]).subtract(1, "days").format(format || DATE_FORMAT),
                        moment(props.dataFilters[i]["value2"]).add(1, "days").format(format || DATE_FORMAT)
                      )
                  );
                  setDisplayData({
                    data: updateData,
                  });
                }
              } else if (props.dataFilters[i].filterType === "con") {

                updateData = updateData.filter(
                  (rd) =>
                    rd[props.dataFilters[i]["fieldName"]].toLowerCase().includes(props.dataFilters[i]["value"])
                );

                setDisplayData({
                  data: updateData,
                });
              } else {
                const getFilterdData = () => {
                  if (props.dataFilters[i].dataType === "date") {
                    return updateData.filter(
                      (rd) =>
                        moment(rd[props.dataFilters[i]["fieldName"]]).format(format || DATE_FORMAT) ===
                        moment(props.dataFilters[i]["value"]).format(format || DATE_FORMAT)
                    );
                  } else {
                    return updateData.filter(
                      (rd) =>
                        String(rd[props.dataFilters[i]["fieldName"]]) ===
                        String(props.dataFilters[i]["value"])
                    );
                  }
                }
                if (props?.aggGroupBuilders) {
                  const { data, fields } = getGroupedData(getFilterdData());
                  console.log("DATA===>>", data)
                  setDisplayData({ data });
                  setFieldNames(availableFieldsSet);

                } else {
                  setDisplayData({ data: getFilterdData() });
                  setFieldNames(availableFieldsSet);
                }
              }
            }
          }
        } else if (
          props.selectedResource === null ||
          props.dataFilters.length === 0
        ) {
          // setDisplayData({data: ""});
          if (props?.aggGroupBuilders && props?.aggGroupBuilders.length > 0) {
            const { data, fields } = getGroupedData(props?.reportData?.data);
            console.log("DATA===>>", data)
            setDisplayData({ data });
            setFieldNames(availableFieldsSet);

          } else {
            setDisplayData({ data: props.reportData.data });
            setFieldNames(availableFieldsSet);
          }
        }
      }

      // if (props?.aggGroupBuilders) {
      //   const { data, fields } = getGroupedData(displayData.data);
      //   console.log("DATA===>>", data)
      //   setDisplayData({data: data});

      // }
    }
  }, [props]);




  const getGroupedData = (reportData) => {
    console.log("REPORT DATA===>>", reportData)
    let groupByKeys = props.aggGroupBuilders?.fieldNamesList ?? [];
    let sumKeys = props.aggGroupBuilders?.sumFieldNamesList ?? [];
    let result = getSumOfGroupByMultiFields(reportData, groupByKeys, sumKeys);
    let count = groupingByMultipleFields(reportData, function (item) {
      return groupByKeys?.map((key) => item[key]);
    });

    result = result?.map((obj) =>
      Object.fromEntries(
        Object.entries(obj)?.filter(
          (o) =>
            props.aggGroupBuilders?.displayFieldNamesList?.includes(o[0]) ||
            props.aggGroupBuilders?.uniqueFieldNamesList?.includes(o[0])
        )
      )
    );

    let columns = Object.keys(result[0]).map((val, i) => ({
      id: i,
      fieldName: val,
      checked:
        props.availableFields?.find(
          (af) => af.fieldName === val
        )?.checked ?? true,
      dataType: props.allFields?.find(
        (af) => af.fieldName === val
      )?.dataType,
      // a grouped column keeps the width saved for the field it groups
      width: props.availableFields?.find(
        (af) => af.fieldName === val
      )?.width,
      grouped: true,
    }));

    if (props.aggGroupBuilders?.operator === 'sum&count' || props.aggGroupBuilders?.operator === 'count') {
      count = count?.map((c) => c?.length);

      columns.push({
        id: v4(),
        fieldName: "Count",
        checked:
          props.availableFields?.find(
            (af) => af.fieldName === "Count"
          )?.checked ?? true,
        dataType: "number",
        grouped: true,
      });

      result = result.map((res, i) => ({ ...res, 'Count': count[i] }))

      return {
        data: result?.length ? result : [],
        fields: columns?.length ? columns : [],
      };
    } else {
      return {
        data: result?.length ? result : [],
        fields: columns?.length ? columns : [],
      };
    }
  };

  /* ── DOWNLOAD ──
     Every format is written from displayData — the same rows the table is drawing, after
     grouping and after data filters — and from fieldNames, the same columns. A file that
     did not match the screen would look like the wrong data.

     Note this is the whole result set, not the page on screen: the table paginates, and a
     reader asking for a download wants the rows below the fold as well. Nothing here
     reads the rendered table for that reason. */
  const exportContext = () => ({
    rows: displayData?.data,
    fields: fieldNames,
    widgetName: props?.widgetName,
    boardName: props?.boardName,
    // named in the heading block, so a file says which slice of the data it holds
    filters: describeDataFilters(props?.dataFilters),
    generatedBy: user?.user?.username,
  });

  const handleExport = (format) => {
    const context = exportContext();
    if (format === "csv") return exportRowsToCsv(context);
    if (format === "xlsx") return exportRowsToXlsx(context);
    if (format === "pdf") return exportRowsToPdf(context);
    if (format === "png") return exportRowsToPng(context);
    return false;
  };

  /* On a one-widget board this header is hidden and the page header carries the menu, so
     the board hands its export routine upwards for the toolbar to call. */
  useEffect(() => {
    if (typeof props.onRegisterExport === "function") props.onRegisterExport(handleExport);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayData, fieldNames, props.dataFilters, props.widgetName, props.boardName]);

  /* ── THE EMAIL ATTACHMENT ──
     The same PDF the Download menu writes, handed back as base64 instead of saved - see
     buildRowsPdfAttachment. Registered the same way and from the same exportContext(), so
     the file someone is mailed holds the rows and the filters that were on screen when
     Send was pressed, not the report's saved state. */
  const buildEmailAttachment = () => buildRowsPdfAttachment(exportContext());

  /* On a one-widget board this header is hidden, so the count has nowhere to go from here
     - the page header shows it instead and needs telling. Same arrangement as the export
     registration above. */
  useEffect(() => {
    if (typeof props.onRowCount === "function") props.onRowCount(displayData?.data?.length);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayData]);

  useEffect(() => {
    if (typeof props.onRegisterEmailAttachment === "function") {
      props.onRegisterEmailAttachment(buildEmailAttachment);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayData, fieldNames, props.dataFilters, props.widgetName, props.boardName]);

  const handleDownloadCsv = () => {
    const written = exportRowsToCsv(exportContext());
    if (!written) message.warning("There is no data to download for this widget");
  };

  /* ── COLUMN DATA FILTERS ────────────────────────────────────────────────────
     A funnel on any column the report has a data filter for, opening the same
     popover the host app shows (witmeg-reporting-embed-v2, TableWidget). Apply
     writes the value back onto the resource and hands it to the board, which is
     exactly what the old Data Filters tab did - only the placement changed, so the
     filtering path below (applyDataFilters) is untouched.

     Absent unless the board view passes filterResource, so the editor's copy of
     ReportGrid keeps its plain headers. */
  const columnFilters = props?.filterResource?.dataFilters || [];

  const filterForColumn = (field) => {
    const name = field?.fieldName ?? field?.dataIndex ?? field?.title;
    return columnFilters.find((f) => f?.fieldName === name) || null;
  };

  const writeFilter = (filter, patch) => ({
    ...props.filterResource,
    dataFilters: columnFilters.map((f) => (f.id === filter.id ? { ...f, ...patch } : f)),
  });

  const renderColumnTitle =
    props?.filterResource && columnFilters.length && props?.onApplyDataFilter
      ? (field, plainTitle) => {
          const filter = filterForColumn(field);
          if (!filter) return plainTitle;

          const active = isFilterActive(filter);

          return (
            <span className="cdf-header">
              <span className="cdf-title">{plainTitle}</span>
              <Popover
                trigger="click"
                placement="bottom"
                overlayClassName="cdf-overlay"
                content={
                  <ColumnDataFilter
                    filter={filter}
                    columnTitle={plainTitle}
                    availableFields={props?.availableFields}
                    onApply={(f, patch) => props.onApplyDataFilter(writeFilter(f, patch))}
                    onReset={(f) => props.onApplyDataFilter(writeFilter(f, { value: null, value1: null, value2: null }))}
                  />
                }
              >
                <button
                  type="button"
                  className={`cdf-trigger${active ? " cdf-trigger--active" : ""}`}
                  title={`Filter ${plainTitle}`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
                    <path
                      d="M2 3h12l-4.5 5.5V13L6.5 11.5v-3z"
                      fill={active ? "currentColor" : "none"}
                      stroke="currentColor"
                      strokeWidth="1.2"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </Popover>
            </span>
          );
        }
      : undefined;

  return (
    <div ref={widgetRef} style={{ background: "#fff" }} className='board-datatable-container'>
      {/* A one-widget board draws no header - the page above it already carries the name,
          so the bar was the same title a second time, and its download menu sits in the
          page header instead. Dashboards with several widgets keep it: there the name is
          the only thing identifying which widget is which. */}
      {props?.hideHeader ? null : (
        <WidgetHeader
          title={props?.widgetName ?? ""}
          // after grouping and after the data filters - the rows actually on the table
          rowCount={displayData?.data?.length}
          properties={props?.widgetProperties}
          onDownload={handleDownloadCsv}
          onExport={handleExport}
          fullScreenTargetRef={widgetRef}
        />
      )}
      <>
        {
          <div>
            {fieldNames?.length &&
              displayData?.data?.length &&
              props?.availableFields?.length ? (
              !props?.aggRowBuilders?.length ? (
                <ReportGrid
                  reportData={displayData}
                  availableFields={fieldNames}
                  aggGroupBuilders={props.aggGroupBuilders}
                  drillDowns={props.drillDowns}
                  renderColumnTitle={renderColumnTitle}
                />
              ) : (
                <ReportGrid
                  reportData={displayData}
                  availableFields={fieldNames}
                  aggRowBuilders={props.aggRowBuilders}
                  aggGroupBuilders={props.aggGroupBuilders}
                  drillDowns={props.drillDowns}
                  renderColumnTitle={renderColumnTitle}
                />
              )
            ) : (
              /* Bare text with no padding read as a broken widget. When the user got here
                 by drilling down, say that the filter matched nothing rather than
                 implying the report itself is empty. */
              <div className="report-empty">
                <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" width="40" height="40">
                  <rect x="8" y="10" width="32" height="28" rx="3" />
                  <path d="M8 18h32M18 18v20M8 26h32" />
                </svg>
                <div className="report-empty-title">
                  {props.drillDownFiltered ? "No matching records" : "No data"}
                </div>
                <div className="report-empty-text">
                  {props.drillDownFiltered
                    ? "This report has no rows for the value you drilled into."
                    : "This report returned no rows."}
                </div>
              </div>
            )}
          </div>
        }
      </>
      {/* ── CREATED BY / DATE / TIME ──
          Moved out of the widget. On a dashboard this block repeated under every widget
          even though it describes the BOARD, not the widget, so a four-widget board
          showed the same three lines four times. It is now rendered once, as its own
          card below the widgets - see renderBoardMeta() in views/Dashboard/index.js. */}
      {/*
      <div
        style={{
          padding: "20px",
          paddingTop: "8px",
          fontSize: "0.9rem",
          textAlign: "left"
        }}
      >
        {user?.user?.username && (
          <div style={{ display: 'flex' }}>
            <h5>Created By :&nbsp;</h5>
            <h5>{user?.user?.username ?? ""}</h5>
          </div>
        )}
        {props?.createdAt && (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <h5>Created Date</h5>
              <h5>
                {props?.createdAt
                  ? getCurrentDate("-", new Date(props.createdAt))
                  : ""}
              </h5>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <h5>Created Time</h5>
              <h5>
                {props?.createdAt
                  ? new Date(props.createdAt).toLocaleTimeString()
                  : ""}
              </h5>
            </div>
          </>
        )}
      </div>
      */}
    </div>
  );
}
